export default __webpack_public_path__ + "static/media/10.aafe30f3.mp3";